export default __webpack_public_path__ + "static/media/Weather-Dashboard-img-2.819e2c50.gif";